import React, { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchFinancialDocument } from "../../../lib/financialDocument";
import { financialDocumentQueryKeys } from "../lib";
import { FinancialDocumentDetails } from "./FinancialDocumentDetails";
import { usePathBasedFinancialDocumentDetailsView } from "./usePathBasedFinancialDocumentDetailsView";
import { financialDocumentDetailsContext } from "./financialDocumentDetails.context";

interface Props {
    financialDocumentId: number;
}

export const FinancialDocumentDetailsContainer: React.FC<Props> = ({
    financialDocumentId,
}) => {
    const { currentView, go } = usePathBasedFinancialDocumentDetailsView();

    const { data: financialDocument } = useQuery({
        queryKey: financialDocumentQueryKeys.detail(financialDocumentId),
        queryFn: () => fetchFinancialDocument(financialDocumentId),
    });

    const contextValue = useMemo(
        () => ({
            currentView,
            changeView: go,
        }),
        [currentView, go],
    );

    if (!financialDocument) {
        return null;
    }

    return (
        <financialDocumentDetailsContext.Provider value={contextValue}>
            <FinancialDocumentDetails financialDocument={financialDocument} />
        </financialDocumentDetailsContext.Provider>
    );
};
